"use client"
import { create } from "zustand"

interface ArtisanatCategoryState {
  artisanats: any[]
  artisanat: any | null
  error: string | null
  loading: boolean

  fetchArtisanats: () => Promise<void>
  fetchArtisanat: (slug: string) => Promise<void>
}

export const useArtisanatCategoryStore = create<ArtisanatCategoryState>((set) => ({
  artisanats: [],
  artisanat: null,
  error: null,
  loading: false,

  //------------------------------------
  // 📌 Fetch ALL artisanat categories
  //------------------------------------
  fetchArtisanats: async () => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}artisanat`
      )
      if (!res.ok) throw new Error("Failed to fetch artisanat categories")

      const data = await res.json()
      set({ artisanats: data.data })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },

  //------------------------------------
  // 📌 Fetch ONE artisanat category
  //------------------------------------
  fetchArtisanat: async (slug: string) => {
    set({ loading: true, error: null })
    try {
      const res = await fetch(
        `${process.env.NEXT_PUBLIC_API_URL}artisanat`
      )
      if (!res.ok) throw new Error("Failed to fetch artisanat category")

      const data = await res.json()
      const myCategory = data.data.find((x: any) => x.slug === slug)

      set({ artisanat: myCategory })
    } catch (err: any) {
      set({ error: err.message })
    } finally {
      set({ loading: false })
    }
  },
}))
